// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'futuraPTProMedium', 'futuraPTProMedium Fallback'"},"className":"__className_33e350","variable":"__variable_33e350"};